import React from 'react';
import { useTranslation } from 'react-i18next';
import { fetchHotGames } from '@/services/api';
import GameCards from '@/components/home/GameCards/GameCards';

/**
 * Hot Games Component
 * Displays trending/popular games from GIS API
 * Uses the reusable GameCards component
 */
const HotGames = () => {
  const { t } = useTranslation();
  return (
    <GameCards
      title={t('home.hotGames')}
      fetchFunction={fetchHotGames}
      launchFunction={null}
      queryKey={['hotGames']}
      itemsPerPage={20}
    />
  );
};

export default HotGames;
